import { WebRender2DPass } from "./WebRender2DPass";
export class Web2DGraphicsBufferDataView {
}
export class Web2DGraphic2DVertexDataView extends Web2DGraphicsBufferDataView {
    _getData() {
        return this._view;
    }
    _modify() {
        this.owner._modifyOneView(this);
        WebRender2DPass.setBuffer(this.owner);
    }
    _updateView(wholeData) {
        if (!this._view || this._view.buffer !== wholeData.buffer) {
            this._view = new Float32Array(wholeData.buffer, this.start * 4, this.length);
        }
    }
    setData(data) {
        this._view.set(data);
        this._modify();
    }
    constructor(owner, start, length, stride = 1) {
        super();
        this.stride = 1;
        this.owner = owner;
        this.start = start;
        this.length = length;
        this.stride = stride;
        this._updateView(owner._dataView);
        owner.addDataView(this);
    }
}
export class Web2DGraphic2DIndexDataView extends Web2DGraphicsBufferDataView {
    setGeometry(value) {
        this._geometry = value;
    }
    setData(data) {
        this._view.set(data);
        this._modify();
    }
    constructor(owner, length, create = true) {
        super();
        this.owner = owner;
        this.length = length;
        if (create) {
            this._view = new Uint16Array(length);
        }
    }
    _updateView(wholeData) {
        wholeData.set(this._view, this.start);
    }
    _modify() {
        this.owner._modifyOneView(this);
        WebRender2DPass.setBuffer(this.owner);
    }
    _clone(cloneOwner = true, create = true) {
        let owner = cloneOwner ? this.owner : null;
        let nview = new Web2DGraphic2DIndexCloneDataView(owner, this.length, create);
        if (!create) {
            this._cloneView(nview);
        }
        return nview;
    }
    _cloneView(view) {
        view._view = this._view;
        view.length = this.length;
    }
    destroy() {
        this._view = null;
        this._geometry = null;
        this.owner = null;
        this._next = null;
        this._prev = null;
    }
}
export class Web2DGraphic2DIndexCloneDataView extends Web2DGraphic2DIndexDataView {
    destroy() {
        super.destroy();
    }
}
